export default function getPageName() {
  const { namespace, controller, action } = document.body.dataset
  let pageName = ''

  if (namespace && namespace !== 'false')
      pageName += `${namespace}/`

  pageName += `${controller}#${action}`

  return pageName
}
